import L from "leaflet";

export function createIcon(point) {
    let className = "map-point";
    let innerContent = "";

    if (point.flagged) {
        className += " map-point-success";
        innerContent = `
                <div class="point-inner">
                    <div class="point-checkmark">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M13 4L6 11L3 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="point-glow"></div>
                </div>
            `;
    } else if (point.locked) {
        className += " map-point-locked";
        innerContent = `
                <div class="point-inner">
                    <div class="point-lock">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <rect x="2" y="5" width="8" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
                            <path d="M3.5 5V3.5C3.5 2.11929 4.61929 1 6 1C7.38071 1 8.5 2.11929 8.5 3.5V5" stroke="currentColor" stroke-width="1.5"/>
                        </svg>
                    </div>
                </div>
            `;
    } else {
        className += " map-point-active";
        innerContent = `
                <div class="point-inner">
                    <div class="point-core"></div>
                    <div class="point-ring"></div>
                    <div class="point-pulse"></div>
                </div>
            `;
    }

    return L.divIcon({
        iconSize: [32, 32],
        iconAnchor: [16, 18],
        className: className,
        html: innerContent
    });
}
